import { useNavigate, useLocation } from 'react-router-dom';

interface UseBackNavigationProps {
  onBack?: () => void;
  backUrl?: string;
}

export const useBackNavigation = ({ onBack, backUrl }: UseBackNavigationProps = {}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Try props, then location.state, then query param
  let resolvedBackUrl = backUrl;
  if (!resolvedBackUrl && location.state && (location.state as any).backUrl) {
    resolvedBackUrl = (location.state as any).backUrl;
  }
  if (!resolvedBackUrl) {
    const params = new URLSearchParams(location.search);
    const urlParam = params.get('backUrl');
    if (urlParam) resolvedBackUrl = urlParam;
  }

  const handleBack = () => {
    if (onBack) return onBack();
    if (resolvedBackUrl) return navigate(resolvedBackUrl);
    // Fallback: parent path
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const pathSegments = currentPath.split('/').filter(Boolean);
    pathSegments.pop(); // Remove the last segment
    
    // Rebuild the path and navigate
    const newPath = `/${pathSegments.join('/')}`;
    return navigate(newPath);
  };

  return {
    handleBack,
  };
};
